import { useLocalstorage } from '../localStorage/store'
import type {Reallocatedarea} from '~/models/reallocatedArea'
import {ReallocatedAreaApi} from "~/gen/openapi/sblService";
import {useAxiosClient} from "~/use/axios/client";

const { persist } = useLocalstorage()

const state = reactive({
  reallocatedareas: persist('reallocatedareas', []),
  lastFetchedReallocatedareas: persist<number>('lastFetchedReallocatedareas', 0),
})

const reallocatedareas = computed((): Reallocatedarea[] => state.reallocatedareas)
const lastFetchedReallocatedareas = computed((): number => state.lastFetchedReallocatedareas)

const clearReallocatedareas = (): void => {
  state.reallocatedareas = []
}

const setReallocatedareas = (reallocatedareas: Reallocatedarea[]): void => {
  state.reallocatedareas = reallocatedareas
}

const loadReallocatedareas = async (force?: boolean): Promise<void> => {
  if (!force &&
      state.reallocatedareas.length &&
      lastFetchedReallocatedareas &&
      lastFetchedReallocatedareas.value > Date.now() - 1000 /*ms*/ * 60 /*seconds*/ * 60 /*minutes*/
  ) {
    return
  }
  const { axiosClient } = useAxiosClient()
  const reallocatedAreaApi = new ReallocatedAreaApi(undefined, '', axiosClient.value)

  try {
    const reallocatedAreas: Reallocatedarea[] = (await reallocatedAreaApi.reallocatedAreaGetReallocatedAreas()).data
    setReallocatedareas(reallocatedAreas)
    state.lastFetchedReallocatedareas = Date.now()
  } catch (e) {
    console.error('Failed to load reallocated areas', e)
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useReallocatedareasStore = () => ({
  clearReallocatedareas,
  loadReallocatedareas,
  reallocatedareas
})
